import { TimelineConnector } from "@mui/lab";
import { styled, Box } from "@mui/material";

export const LocationTimelineContainer = styled(Box)(() => ({
  "& .MuiTimeline-root": {
    padding: "6px 0px",
    marginBottom: "24px"
  },
  "& .MuiTimelineItem-root": {
    minHeight: "auto"
  },
  "& .MuiTimelineContent-root": {
    flex: "1 1 auto",
    minWidth: 0,
    padding: "6px 16px"
  },
  "& .MuiTimelineOppositeContent-root": {
    flex: "0 0 auto",
    padding: "6px 16px",
    maxWidth: "80px"
  }
}));

export const LocationTimelineWrapper = styled(Box)<{
  color: string;
  color2?: string;
  height?: string;
}>(({ color, color2, height }) => ({
  "& .MuiTimelineDot-root": {
    backgroundColor: color,
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Gilroy",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "120%",
    display: "flex",
    width: "32px",
    height: "32px",
    padding: "4px",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    margin: "0px"
  },

  "& .MuiTimelineConnector-root": {
    height: height || "150px" // Increased height for more space
  },

  "& .MuiTimelineItem-root:before": {
    content: "none"
  },

  "& .MuiTimelineItem-root": {
    marginBottom: "16px" // Added margin between timeline items
  }
}));

export const TimelineContentWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "14px",
  marginLeft: "4px",
  width: "100%",
  minWidth: 0,

  "& h3": {
    fontFamily: "Gilroy",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "120%",
    color: "#1D1F2B",
    marginTop: "0px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    hyphens: "auto",
    width: "100%"
  }
});

export const TimelineContentDetailsWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "9px",

  "& h3": {
    fontFamily: "Gilroy",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "112%",
    color: "#1D1F2B"
  }
});

export const TimelineContentDetail = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "10px",

  "& p": {
    color: "#323946",
    fontFamily: "Gilroy",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "115%"
  },

  "& svg": {
    color: "#959EB2"
  }
});

export const TimelineBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "26px",
  width: "26px",
  backgroundColor: "#FFFF"
});

export const CustomTimelineConnector = styled(TimelineConnector)({
  "&.MuiTimelineConnector-root": {
    backgroundColor: "#D5D9E8",
    width: 1
  }
});
